import React from "react"

import { GenericWriteForm } from "QuorumGrassroots/campaign-forms/components/ReusableForms/GenericWriteForm"

export const VisitOfficeForm = (props) => <GenericWriteForm {...props} />
